// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#page[data-v-97a4f43a]{width:100%}.page-fill-height[data-v-97a4f43a]{height:100%}.content[data-v-97a4f43a]{padding:0!important}", ""]);
// Exports
module.exports = exports;
